import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import {
  Button,
  CircularProgress,
  Grid,
  Tooltip,
  withStyles,
} from "@material-ui/core";

import SectionHeader from "../../components/UI/SectionHeader";

import { appAction, householdAction, portfolioAction } from "../../actions";

import { isBasicView, isPremiumView } from "../../utilities/access";

import {
  CreatePortfolioDialog,
  HouseholdDetails,
  RecommendedPortfolio,
  PortfolioTable,
  OnboardButton,
} from "./components";

import OnboardPortfoliosDialog from "../../components/OnboardPortfoliosDialog";
import DownloadReport from "./components/DownloadReport";

const styles = (theme) => ({
  actionIconBtns: {
    [theme.breakpoints.down("md")]: {
      whiteSpace: "nowrap",
    },
  },
  fRight: {
    float: "right",
  },
  portfolioActionsContainer: {
    marginBottom: 30,
    clear: "both",
  },
  mainButton: {
    marginRight: 24,
    [theme.breakpoints.down("md")]: {
      marginBottom: "4%",
      fontSize: 12,
      marginRight: "-8%",
      minHeight: 0,
      padding: "6px 7px",
    },
  },
  table: {
    [theme.breakpoints.down("md")]: {
      width: "110%",
    },
    "& th": {
      color: theme.palette.primary.main,
      fontSize: 14,
      padding: "4px 10px",
      fontWeight: 500,
      height: "48px",
    },
    "& td": {
      fontSize: 14,
      padding: "4px 10px",
      [theme.breakpoints.down("md")]: {
        padding: "2px",
        fontSize: 12,
      },
    },
  },
  nowrap: {
    whiteSpace: "nowrap",
  },
  editBtn: {
    cursor: "pointer",
    marginLeft: "3px",
    fontSize: "15px",
  },
  center: {
    textAlign: "center",
  },
  buttonRow: {
    width: "100%",
    marginBottom: "3%",
  },
  dataBoxBtn: {
    fontSize: "13px",
    float: "right",
  },
  cardWrapper: {
    [theme.breakpoints.down("md")]: {
      width: "110%",
      overflow: "auto",
      marginBottom: "4%",
    },
  },
  dateRangeWrapper: {
    width: "100%",
    display: "inline-block",
    marginBottom: "1rem",
  },
  validationMessage: {
    color: theme.palette.error.main,
    paddingTop: "1%",
    display: "block",
  },
});

class HouseholdDetail extends React.Component {
  state = {
    addingPortfolio: false,
    onboardingPortfolios: false,
    orderBy: "updatedAt",
    order: "desc",
    adminView: this.props.history.location.pathname.includes(
      "/Portal/admin/household"
    ),
    bundledPortfolios: [],
  };

  archivePortfolio = (archivingPortfolioId) => {
    this.props.dispatch(portfolioAction.archivePortfolio(archivingPortfolioId));
  };

  createPortfolio = ({ name, initialInvestment }) => {
    this.props.dispatch(
      portfolioAction.createPortfolio(
        this.props.householdId,
        name,
        initialInvestment
      )
    );
  };

  handleRequestSort = (event, property, extraOrdering) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, extraOrdering });
  };

  handleBundlePortfolio = (portfolio) => (e) => {
    this.setState((prevState) => {
      const findIndex = prevState.bundledPortfolios.findIndex(
        (el) => el.uuid === portfolio.uuid
      );
      if (findIndex === -1) {
        return {
          bundledPortfolios: [...prevState.bundledPortfolios, portfolio],
        };
      } else {
        const newArray = prevState.bundledPortfolios.filter((el) => el.uuid !== portfolio.uuid);
        return { bundledPortfolios: newArray };
      }
    });
  };

  /* Return DataBox component with default poftfolio data  */
  renderDefaultPortfolioCard = (household) => {};

  /* 
    Return
    - 'Add Portfolio' button
    - Disabled 'Add portfolio' button when the household initial investment is 0
    - Disabled button has a hover tooltip 
  */
  renderAddPortfolioButton() {
    const { household } = this.props;
    if (household.householdDetail.initialInvestment !== 0) {
      return this.addingPortfolio();
    } else {
      return (
        <Tooltip
          title="Portfolio cannot be created when household investment amount is 0"
          placement="top-start"
        >
          <div>{this.addingPortfolio(true)}</div>
        </Tooltip>
      );
    }
  }

  /*
    Return
    - 'Add Portfolio' button with disable controlled
  */
  addingPortfolio(disabled = false) {
    const { classes } = this.props;
    return (
      <Button
        variant="contained"
        color="primary"
        className={`${classes.mainButton}`}
        onClick={() => this.setState({ addingPortfolio: true })}
        disabled={disabled}
        data-cy="household.addPortfolio"
      >
        Add Portfolio
      </Button>
    );
  }

  onboardPortfolios = () => {
    this.setState({ onboardingPortfolios: true });
  };

  refetchHouseholdWithPortfolios = () => {
    this.props.dispatch(
      householdAction.getHouseholdById(this.props.match.params.householdId)
    );
    this.setState({ bundledPortfolios: [] });
  };

  componentDidMount() {
    this.props.dispatch(
      householdAction.getHouseholdById(this.props.match.params.householdId)
    );

    if (this.state.isPhone) {
      this.props.dispatch(appAction.toggleMainNav(false));
    }

    if (this.state.adminView) {
      this.props.dispatch(appAction.toggleMainNav(false));
      this.props.dispatch(appAction.setAdminNav(true));
    } else {
      this.props.dispatch(appAction.setPortfolioNav());
      this.props.dispatch(appAction.toggleMainNav(true));
    }

    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      // A new portfolio was created when there wasn't a created one previously
      (!prevProps.createPortfolio &&
        this.props.createPortfolio &&
        this.props.createPortfolio.uuid) ||
      // A new portfolio was created when there WAS a created one previously
      (prevProps.createPortfolio &&
        this.props.createPortfolio &&
        prevProps.createPortfolio.uuid !== this.props.createPortfolio.uuid)
    ) {
      this.props.history.push(
        `/Portal/household/${this.props.householdId}/portfolio/${this.props.createPortfolio.uuid}`
      );
    }

    // Redirect to dashboard if current household is successfully removed
    if (prevProps.household.isRequesting && this.props.household.isSuccess) {
      this.props.history.push('/Portal/dashboard');
    }

    /**
     * If any porfolio was deleted from household, remove it from bundled porfolios as well.
     */

    function mapBundledPortfolios(household) {
      return (
        (household.householdDetail && household.householdDetail.Portfolios && household.householdDetail.Portfolios.filter(
            (portfolio) => portfolio.onboardStatus === "in-review"
          )) ||
        []
      );
    }
    const prevBundledPortfolios = mapBundledPortfolios(prevProps.household);

    const { household } = this.props;
    const newBundledPortfolios = mapBundledPortfolios(household);

    /**
     * Skip if bundled portfolios are empty or less than previous states.
     */
    if (prevState.bundledPortfolios.length && (newBundledPortfolios.length < prevBundledPortfolios.length)) {
      const validPortfolios = newBundledPortfolios.map((_) => _.uuid);
      const stillValidNewPortfolio = prevBundledPortfolios.filter(
        (_) => validPortfolios.includes(_.uuid)
      );
      this.setState({ bundledPortfolios: stillValidNewPortfolio });
    }
  }

  render() {
    const { classes, custodianMap, household, appName, accessLevel } = this.props;
    const { adminView, bundledPortfolios } = this.state;
    const householdPortfolios =
      (household.householdDetail && household.householdDetail.Portfolios) || [];

    if (household.householdDetailLoading) {
      return <CircularProgress size={50} />;
    }

    if (
      !household.householdDetail ||
      !household.householdDetail.advisors.length
    ) {
      return null;
    }

    return (
      <React.Fragment>
        <SectionHeader text={household.householdDetail.name || "Household"} />
        {adminView ? null : (
          <Grid
            container
            direction="row"
            justify="space-between"
            className={classes.buttonRow}
          >
            <Link to={"/Portal/dashboard"}>
              <Button
                variant="contained"
                color="primary"
                className={classes.mainButton}
              >
                Back to List
              </Button>
            </Link>
          </Grid>
        )}
        <div className={classes.cardWrapper}>
          {!isBasicView(accessLevel) && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <HouseholdDetails
                  adminView={adminView}
                  custodianMap={custodianMap}
                  householdDetails={household.householdDetail}
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={4}>
                <RecommendedPortfolio
                  classes={this.props.classes}
                  household={household}
                  householdId={this.props.householdId}
                  pathname={this.props.history.location.pathname}
                />
              </Grid>
            </Grid>
          )}

          <CreatePortfolioDialog
            household={household}
            isOpen={this.state.addingPortfolio}
            onCancel={() => this.setState({ addingPortfolio: false })}
            onCreate={(params) => this.createPortfolio(params)}
            classes={classes}
          />
          {!adminView && (
            <div className={classes.portfolioActionsContainer}>
              {this.renderAddPortfolioButton()}
              { isPremiumView(accessLevel) && (
                // user.user.hasValidRepCode && user.user.brokerDealer.verified &&
                <OnboardButton
                  disabled={bundledPortfolios.length === 0}
                  onClick={this.onboardPortfolios}
                />
              )}
              <DownloadReport householdId={this.props.householdId}/>
            </div>
          )}
          <PortfolioTable
            archivePortfolio={this.archivePortfolio.bind(this)}
            classes={this.props.classes}
            custodianMap={custodianMap}
            household={household}
            householdPortfolios={householdPortfolios}
            handleSort={this.handleRequestSort}
            order={this.state.order}
            orderBy={this.state.orderBy}
            pathname={this.props.history.location.pathname}
            bundledPortfolios={bundledPortfolios}
            handleBundlePortfolio={this.handleBundlePortfolio}
            adminView={adminView}
            accessLevel={accessLevel}
            appName={appName}
          />
          {this.state.onboardingPortfolios && (
            <OnboardPortfoliosDialog
              isOpen={true}
              isMultiple={bundledPortfolios.length > 1}
              household={household.currentHousehold}
              onCancel={() => this.setState({ onboardingPortfolios: false })}
              selectedPortfolios={bundledPortfolios}
              callbacks={this.refetchHouseholdWithPortfolios}
              history={this.props.history}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user,
    accessLevel: state.user.user.userRole && state.user.user.userRole.accessLevel ? state.user.user.userRole.accessLevel : 0,
    createPortfolio: state.portfolio.createPortfolio,
    custodianMap: state.custodian.map,
    household: state.household,
    householdId: ownProps.match.params.householdId,
    appName: state.app.appName
  };
};

export default withStyles(styles)(connect(mapStateToProps)(HouseholdDetail));



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/index.jsx